export default __webpack_public_path__ + "static/media/Abyssal Demon Ring of Assault.e94a673b.jpg";